import { useState } from 'react'

import { TimeRange } from 'common-constants/timeRange'
import { getCountdown } from 'components/block/FeaturedPhotosPromoX3/functions/getCountdown'
import { useInterval } from 'hooks/useInterval'

export const useTimerText = (endDate: number): string | null => {
  const [diff, setDiff] = useState<number | null>(null)

  useInterval(() => {
    setDiff(endDate * 1000 - Date.now())
  }, TimeRange.second)

  if (diff === null) {
    return null
  }

  if (!diff || diff <= 0) {
    return '0:00:00'
  }

  return getCountdown(diff)
}
